// extracted by mini-css-extract-plugin
module.exports = {"badgeWiOptions":"BadgeWithOptions_badgeWiOptions__IKfHS","badgeWiOptions_content":"BadgeWithOptions_badgeWiOptions_content__3PiZl"};